export const manualsAndHandbooksBaseLink =
  'https://productcenter.volvopenta.com/ownerinformation/ManualAndSpecification?displayLang=en-US&searchLang=en-US&serialNumber=';

export const sparePartsBaseLink = import.meta.env.DEV
  ? 'https://preprod.volvopenta.com/shop/0/search?serialnumber='
  : `${window.location.origin}/shop/0/search?serialnumber=`;

export const supportLink = import.meta.env.DEV
  ? 'https://preprod.volvopenta.com/support'
  : `${window.location.origin}/support`;

export const campaignsRecallLink = import.meta.env.DEV
  ? 'https://preprod.volvopenta.com/your-engine/recall-information'
  : `${window.location.origin}/your-engine/recall-information`;

export const productArchiveLink = import.meta.env.DEV
  ? 'https://preprod.volvopenta.com/marine/all-marine-engines/product-archive'
  : `${window.location.origin}/marine/all-marine-engines/product-archive`;

export const productArchiveLinkIndustrialOffroad = import.meta.env.DEV
  ? 'https://preprod.volvopenta.com/industrial/industrial-engines/off-road-engine-range/off-road-product-archive'
  : `${window.location.origin}/industrial/industrial-engines/off-road-engine-range/off-road-product-archive`;

export const productArchiveLinkIndustrialPowerGeneration = import.meta.env.DEV
  ? 'https://preprod.volvopenta.com/industrial/power-generation-engines/power-generation-engine-range/power-gen-product-archive'
  : `${window.location.origin}/industrial/power-generation-engines/power-generation-engine-range/power-gen-product-archive`;

export const dealerLocatorLink = 'https://www.volvopenta.com/about-us/dealer-locator/';

export const privacyPolicyLink = 'https://www.volvopenta.com/legal/privacy-policy/';

export const cookiePolicyLink = 'https://www.volvopenta.com/legal/cookie-policy/';
